export default "__VITE_ASSET__CEZ_E0Zv__"